export default __webpack_public_path__ + "static/media/Jean1.b89e8ae9.mp3";